/*eslint eqeqeq: "off"*/
/*eslint array-callback-return: "off"*/
/*eslint no-use-before-define: "off"*/
/*eslint radix: "off"*/
/*eslint no-redeclare: "off"*/
/* eslint-disable */
import React, { Component } from 'react'

import { connect } from 'react-redux'
import CardUI from '../ui/template/Card'

class Design extends Component {

  //Constructor of the component
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }


  componentWillMount() {

  }
  componentWillUnmount() {
  }

  render() {

    return (
      <div className="row  justify-content-center">
        <div className="card center col-md-12 ml-auto mr-auto">
          <form className="form-horizontal">
            <div className="card-header card-header-text" data-background-color="rose">
              <h4 className="card-title">{"App Design"}</h4>
            </div>
            <br />
            {/* <div className="col-md-12">
              {this.props.children}
            </div> */}
          </form>
        </div>
      </div>

    )
  }
}
const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  updateeventfield: dispatch.eventmodel.updateeventfield
  // addnewsection: dispatch.eventmodel.addnewsection
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Design);


// WEBPACK FOOTER //
// ./src/containers/Design.js